<template>
  <div class="no-data">
    <slot>
      <div class="no-data-text">{{ noDataText }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    noDataText: {
      type: String,
      default: '데이터가 없습니다.'
    }
  }
}
</script>
